import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { StyledButton, StyledButtonLink, StyledIcon, StyledTooltip } from './styled';

const IconButton = ({ children, backgroundColor, disabled, type, size, to, customStyle, title, onClick }) => {
  const buttonRef = useRef(null);
  const tooltipRef = useRef(null);

  const handleMouseEnter = () => {
    if(buttonRef.current && tooltipRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      tooltipRef.current.style.top = `${buttonRect.bottom}px`;
      tooltipRef.current.style.left = `${buttonRect.left}px`;
      tooltipRef.current.style.transform = `translateX(calc(-50% + ${buttonRect.width/2}px))`;
    }
  }

  return (
    <StyledButton
      ref={buttonRef}
      as={!!to || type === 'navlink' ? 'div' : 'button'}
      backgroundColor={backgroundColor}
      disabled={disabled}
      type={!!!to ? type : undefined}
      size={size}
      customStyle={customStyle}
      onClick={onClick}
      onMouseEnter={title && handleMouseEnter}
    >
      {
        (!!to || type === 'navlink') &&
        <StyledButtonLink
          as={type === 'navlink' && NavLink}
          to={to}
        />
      }
      <StyledIcon>{children}</StyledIcon>
      {
        title &&
        <StyledTooltip
          ref={tooltipRef}
        >
          {title}
        </StyledTooltip>
      }
    </StyledButton>
  );
};

IconButton.propTypes = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'navlink']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  customStyle: PropTypes.array,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

IconButton.defaultProps = {
  backgroundColor: null,
  disabled: false,
  type: 'button',
  size: 'medium',
  onClick: undefined,
};

export default React.memo(IconButton);
